import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from 'src/i18n';
import { TinyEmitter } from 'tiny-emitter';

Vue.use(VueI18n);

class LanguageManager extends TinyEmitter {
  availableLanguages = [
    { code: 'fr-fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en-us', name: 'English', flag: '🇺🇸' }
  ];

  get currentLocaleLang() {
    return i18n.locale.split('-')[0];
  }

  detectLanguage() {
    const savedLocale = localStorage.getItem('locale');
    if (savedLocale && messages[savedLocale]) {
      return savedLocale;
    }

    // Get browser language
    const browserLang = navigator.language || navigator.userLanguage;

    // Map browser language to available locales
    const languageMap = {
      'fr': 'fr-fr',
      'fr-FR': 'fr-fr',
      'fr-fr': 'fr-fr',
      'en': 'en-us',
      'en-US': 'en-us',
      'en-us': 'en-us',
      'en-GB': 'en-us',
    };

    // Check exact match first
    if (languageMap[browserLang]) {
      return languageMap[browserLang];
    }

    // Check language prefix (e.g., 'fr-CA' -> 'fr')
    const langPrefix = browserLang.split('-')[0];
    if (languageMap[langPrefix]) {
      return languageMap[langPrefix];
    }

    // Default fallback
    return 'en-us';
  }

  setLanguage(locale) {
    if (messages[locale]) {
      localStorage.setItem('locale', locale);
      window.location.reload();
      return true;
    }
    return false;
  }
}

const languageManager = new LanguageManager();

const i18n = new VueI18n({
  locale: languageManager.detectLanguage(),
  fallbackLocale: 'en-us',
  messages,
});


export default ({ app }) => {
  // Set i18n instance on app
  app.i18n = i18n;
};

export { i18n, languageManager };
